<template>
  <div>
    <div class="titlePageSub mt-3">Cadastro do Status das Inscrições</div>
    <div class="row mt-3" :data-name="statusFinal">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsSolicitacoesStatus"
          :orderby="sortBy"
          :optionsButton="optionsButton"
          :optionsButtonRight="optionsButtonHistorico"
          :items="lstSolicitacaoStatus"
          responsive
          :actions="actions"
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :titlePDF="titlePage"
          :mostrarQuantidade="false"
        ></fccTable>
      </div>
    </div>
    <fcc-modal
      centered
      id-modal="historicoOpen"
      title-modal="Histórico"
      esconde-footer
      trava-esc
      size="lg"
      trava-back
    >
      <div class="row mt-3">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fieldsStatus"
            :orderby="sortBy"
            :items="lstStatus"
            responsive
            :porPage="itemPorPage"
            titlePage="Histórico"
            titlePDF="Histórico"
            :mostrarQuantidade="false"
          ></fccTable>
        </div>
      </div>
    </fcc-modal>
    <fcc-modal
      centered
      id-modal="addStatusInscricoes"
      :title-modal="titleModalSituacao"
      esconde-footer
      trava-esc
      size="lg"
      trava-back
    >
      <b-form
        @submit.prevent="criar.id == 0 ? submitSituacao() : editSituacao()"
        autocomplete="off"
      >
        <div class="row">
          <div class="col-sm-6">
            <fccInput extraClasses="inputLabel" required v-model="criar.cancelado" maxlength="1"
              >Cancelado</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" required v-model="criar.descricao_link"
              >Descrição</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </b-form>
    </fcc-modal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../store'
export default {
  data() {
    return {
      titlePage: 'Publicações',
      titleModalSituacao: '',
      sortBy: 'nome',
      permissao: null,
      lstStatus: [],
      criar: {},
      itemPorPage: '1000',
      lstSolicitacaoStatus: [],
      optionsButtonHistorico: [
        {
          funcaoButton: 'historicoOpen',
          tooltip: 'Histórico',
          icon: 'clock',
          text: 'Histórico',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      fieldsSolicitacoesStatus: [
        { key: 'cancelado', label: 'Cancelado', sortable: true },
        { key: 'descricao_link', label: 'Descrição', sortable: true },
        { key: 'actions', label: '' }
      ],
      fieldsStatus: [
        { key: 'nome_funcionario', label: 'Técnico', sortable: true },
        { key: 'descricao_situacao', label: 'Técnico', sortable: true },
        { key: 'data_finalizacao', label: 'Data da Exportação', sortable: true }
      ],
      actions: [],
      optionsButton: []
    }
  },
  computed: {
    statusFinal() {
      const manipula = this.lstStatus.length
      var manipulaTeste = false
      if (manipula > 0) {
        manipulaTeste =
          this.lstStatus[manipula - 1].descricao_situacao.includes('CADASTRO FINALIZADO')
      }
      this.$emit('statusManipula', manipulaTeste)
      this.manipulaActions(manipulaTeste)
      return manipulaTeste
    }
  },
  methods: {
    manipulaActions(manipula) {
      this.optionsButton = [
        {
          funcaoButton: 'addField',
          tooltip: 'Adicionar',
          icon: 'plus',
          text: 'Adicionar',
          disabled: manipula,
          objpermCodigo: store.state.permissaoMenu.adicionar
        },

        {
          funcaoButton: 'finalizarField',
          tooltip: 'Finalizar',
          disabled: manipula,
          text: 'Finalizar',
          icon: 'check',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          funcaoButton: 'desfazerField',
          tooltip: 'Desfazer',
          icon: 'recycle',
          text: 'Desfazer',
          variant: 'primary',
          disabled: !manipula,
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
      this.actions = !manipula
        ? [
            {
              button: true,
              funcaoButton: 'editStatusInscricoes',
              icon: 'edit',
              tooltip: 'Editar',
              objpermCodigo: store.state.permissaoMenu.editar
            },
            {
              button: true,
              funcaoButton: 'deleteStatusInscricoes',
              icon: 'trash',
              tooltip: 'Excluir',
              objpermCodigo: store.state.permissaoMenu.excluir
            }
          ]
        : [
            {
              button: true,
              funcaoButton: 'bloqueadoStatusInscricoes',
              icon: 'lock',
              tooltip: 'Editar',
              objpermCodigo: store.state.permissaoMenu.editar
            }
          ]
      this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')
      if (this.permissao == null) {
        this.optionsButton = []
        this.actions = [
          {
            button: true,
            funcaoButton: 'bloqueadoStatusInscricoes',
            icon: 'lock',
            tooltip: 'Editar',
            objpermCodigo: store.state.permissaoMenu.editar
          }
        ]
      }
    },
    desfazerField() {
      this.mudarStatusField(2)
    },
    finalizarField() {
      this.mudarStatusField(1)
    },
    bloqueadoStatusInscricoes() {
      this.callAlert(
        'Bloqueado',
        'Para desbloquear é necessário clicar no botão desfazer',
        'error',
        'error'
      )
    },
    deleteStatusInscricoes(_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao_link).then((result) => {
        if (result.value) {
          axios
            .delete(
              store.state.baseUrlPublicacao +
                'InscricoesDeferidasCanceladas/ExcluirSituacaoInscricaoEdital/' +
                item.id_situacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.callToast(this.mensagensUpdate.excluido, 'success')
              this.listarSituacaoInscricaoEdital()
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto())
        }
      })
    },
    historicoOpen() {
      this.$root.$emit('bv::show::modal', 'historicoOpen')
    },
    submitSituacao() {
      const criar = {
        id_Situacao: 0,
        spi: this.controlePage.spi,
        cancelado: this.criar.cancelado,
        descricao_link: this.criar.descricao_link,
        cd_funcionario: this.dadosUserSession.usuCdFuncionario
      }
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao + 'InscricoesDeferidasCanceladas/InserirSituacaoInscricaoEdital',
          criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.criar = {}
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addStatusInscricoes')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.listarSituacaoInscricaoEdital()
        })
        .catch(this.setErrorSystem)
    },
    editSituacao() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlPublicacao + 'InscricoesDeferidasCanceladas/AlterarSituacaoInscricaoEdital',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addStatusInscricoes')
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.listarSituacaoInscricaoEdital()
        })
        .catch(this.setErrorSystem)
    },
    editStatusInscricoes(_, item) {
      this.criar = item
      this.titleModalSituacao = 'Editar Status'
      this.$root.$emit('bv::show::modal', 'addStatusInscricoes')
    },
    mudarStatusField(number) {
      var text = number == 1 ? ' Finalizar' : ' Desfazer'
      this.callConfirm('Deseja realmente ' + text + ' ?', '').then((result) => {
        if (result.value) {
          const criar = {
            spi: this.controlePage.spi,
            cd_funcionario: this.dadosUserSession.usuCdFuncionario,
            tp_situacao: number
          }
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .post(
              this.baseUrlPublicacao +
                'InscricoesDeferidasCanceladas/FinalizarDesfazerControleSituacaoInscricaoEdital',
              criar,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.criar = {}
              this.carregaTexto()
              this.$root.$emit('bv::hide::modal', 'addStatusTestes')
              this.callToast(
                number == 1 ? this.mensagensUpdate.adicionado : this.mensagensUpdate.editado,
                'success'
              )
              this.listarDesfazerFinalizar()
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    addField() {
      this.criar = {}
      this.criar.id = 0
      this.titleModalSituacao = 'Adicionar Status'
      this.$root.$emit('bv::show::modal', 'addStatusInscricoes')
    },
    listarDesfazerFinalizar() {
      this.listarControleSituacaoGenerico(this.controlePage.spi).then((response) => {
        this.lstStatus = response
      })
    },
    listarSituacaoInscricaoEdital() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            'InscricoesDeferidasCanceladas/ListarSituacaoInscricaoEdital/' +
            this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstSolicitacaoStatus = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object,
    idNotificacao: Number,
    baseUrlPublicacao: String
  },
  mounted() {
    this.listarSituacaoInscricaoEdital()
    this.listarDesfazerFinalizar()
  }
}
</script>
